/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type ClinicalReportAnamnesisDtoPreviousDiagnoseStatus =
  (typeof ClinicalReportAnamnesisDtoPreviousDiagnoseStatus)[keyof typeof ClinicalReportAnamnesisDtoPreviousDiagnoseStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClinicalReportAnamnesisDtoPreviousDiagnoseStatus = {
  YES: 'YES',
  NO: 'NO',
  UNKNOWN: 'UNKNOWN',
} as const;
